import moment from 'moment';

class CreatePOPModalController {
  constructor($uibModalInstance, $http, $rootScope, $scope, toastr, contractUrl, existingPOPs) {
    "ngInject";

    this.name = 'CreatePOPModal';
    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.toastr = toastr;
    this.contractUrl = contractUrl;
    this.existingPOPs = existingPOPs || [];

    this.popModel = {
      name: '',
      startDate: undefined,
      endDate: undefined,
      laborEscalationRate: undefined
    };
    this.startDateText = '';
    this.endDateText = '';
    this.endDateMinDate = null;
  }

  isDuplicateName(name) {
    if (!name || !name.trim()) {
      return false;
    }
    const trimmedName = name.trim().toLowerCase();
    return this.existingPOPs.some(pop => pop.name && pop.name.trim().toLowerCase() === trimmedName);
  }

  onStartDateSelected(selectedDate) {
    if (selectedDate) {
      this.popModel.startDate = moment(selectedDate).toDate();
      this.startDateText = moment(selectedDate).format('MMM DD, YYYY');
      this.endDateMinDate = moment(selectedDate).format('YYYY-MM-DD');
      
      // Clear end date if it's before the new start date
      if (this.popModel.endDate && moment(this.popModel.endDate).isBefore(moment(selectedDate), 'day')) {
        this.popModel.endDate = undefined;
        this.endDateText = '';
      }
    }
  }

  onEndDateSelected(selectedDate) {
    if (selectedDate) {
      this.popModel.endDate = moment(selectedDate).toDate();
      this.endDateText = moment(selectedDate).format('MMM DD, YYYY');
    }
  }

  getEndDateMinDate() {
    return this.endDateMinDate;
  }

  save() {
    if (!(this.popModel.name && this.popModel.startDate && this.popModel.endDate)) {
      this.$scope.popForm.$submitted = true;
      return;
    }

    // Check for duplicate name
    if (this.isDuplicateName(this.popModel.name)) {
      this.toastr.error('A period of performance with this name already exists.', 'ERROR');
      return;
    }

    const popData = {
      name: this.popModel.name,
      startDate: this.popModel.startDate.toISOString().slice(0, 10),
      endDate: this.popModel.endDate.toISOString().slice(0, 10),
      laborEscalationRate: this.popModel.laborEscalationRate || null
    };

    this.$http
      .post(this.contractUrl + '/pops', popData, { withCredentials: true })
      .then((response) => {
        this.toastr.success('Successfully added period of performance.', 'SUCCESS');
        this.$uibModalInstance.close(response.data);
      })
      .catch((err) => {
        console.error('Could not add period of performance:', err);
        this.toastr.error('Could not add period of performance.', 'ERROR');
        this.$uibModalInstance.dismiss(err);
      });
  }

  cancel() {
    this.$uibModalInstance.dismiss();
  }
}

export default CreatePOPModalController;




// WEBPACK FOOTER //
// ./client/common/modals/createPOPModal/createPOPModal.controller.js